import styled from 'styled-components';
import { FIAT_MASTER_PLAN_BACKGROUND } from '../../config/media';

export const ConfirmationWrapper = styled.div`
	.has-error {
		background-color: unset !important;
	}
	.enterprise-icon {
		width: 2rem
	}
	.d-flex {
		display: flex;
	}
	.content-text-small {
		color: #A8A8B1;
		font-size: 11px;
	}
	.head {
		font-weight: bold;
	}
	.form-container {
		width: 70%;

		.ant-form-item-control {
			line-height: normal;
		}
		.ant-radio-group,
		.ant-input {
			margin: 0.5rem 0px;
		}
		.budget-options {
			display: flex;
			flex-direction: column;
		}
	}
	.btn-area {
		margin-top: 1.5rem;
		display: flex;
		> * {
			flex: 1;
		}
		.local {
			line-height: 1;
		}
		button {
			font-weight: normal !important;
		}
		.separator {
			margin: 0 0.5rem;
			flex: none;
		}
	}
	.warning-text {
		color: #F83E18;
	}
	.fiat-section {
		color: #fff;
		background-color: #212121;
		padding: 2rem;
		position: relative;
		width: 100%;
		z-index: 1;
		b {
			font-size: 20px;
		}
		.w-75 {
			width: 75%;
		}
	}
	.fiat-section::before {
		content: "";
		background-image: url(${FIAT_MASTER_PLAN_BACKGROUND});
		background-position: right;
		background-size: contain;
		background-repeat: no-repeat;
		background-color: #29292c;
		opacity: 0.4;
		position: absolute;
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
		z-index: -1;
	}
	@media(max-width: 960px) {
		.form-container {
			width: 100%;
		}
	}
`;